/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Rest_Minus_LabelInputs */

const en_us2_workout_rest_minus_label = /** @type {(inputs: Workout_Rest_Minus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 fewer seconds of rest`)
};

const pt_br2_workout_rest_minus_label = /** @type {(inputs: Workout_Rest_Minus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos 15 segundos de descanso`)
};

const es_419_workout_rest_minus_label = /** @type {(inputs: Workout_Rest_Minus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 segundos menos de descanso`)
};

const pt_pt2_workout_rest_minus_label = /** @type {(inputs: Workout_Rest_Minus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos 15 segundos de descanso`)
};

const fr_fr2_workout_rest_minus_label = /** @type {(inputs: Workout_Rest_Minus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 secondes de repos en moins`)
};

const de_de2_workout_rest_minus_label = /** @type {(inputs: Workout_Rest_Minus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 Sekunden weniger Pause`)
};

const it_it2_workout_rest_minus_label = /** @type {(inputs: Workout_Rest_Minus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 secondi di recupero in meno`)
};

/**
* | output |
* | --- |
* | "15 fewer seconds of rest" |
*
* @param {Workout_Rest_Minus_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_rest_minus_label = /** @type {((inputs?: Workout_Rest_Minus_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Rest_Minus_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_rest_minus_label(inputs)
	if (locale === "es-419") return es_419_workout_rest_minus_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_rest_minus_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_rest_minus_label(inputs)
	if (locale === "de-DE") return de_de2_workout_rest_minus_label(inputs)
	if (locale === "it-IT") return it_it2_workout_rest_minus_label(inputs)
	return en_us2_workout_rest_minus_label(inputs)
});
export { workout_rest_minus_label as "workout.rest_minus_label" }